import { trpc } from "../../utils/trpc.js";
import { useEffect, useState } from "react";
import { supalog } from "@proj/supalog";

const VISITOR_PUBLIC_ID_KEY = "supabanner-visitor-public-id";

export function getVisitorPublicId() {
  return localStorage.getItem(VISITOR_PUBLIC_ID_KEY) || undefined;
}

export function EnsureVisitorProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [visitorPublicId, setVisitorPublicId] = useState<string | undefined>(
    getVisitorPublicId()
  );

  const { data } = trpc.ensureVisitorExists.useQuery({
    visitorPublicId,
  });

  useEffect(() => {
    supalog("[Supabanner]: checking if should set new visitor", {
      visitorPublicId,
      remote: data?.visitorPublicId,
    });
    if (!data?.visitorPublicId) return;
    if (visitorPublicId === data?.visitorPublicId) return;

    supalog("[Supabanner]: SETTING NEW VISITOR ID", {
      visitorPublicId,
      remote: data?.visitorPublicId,
    });

    setVisitorPublicId(data?.visitorPublicId);
    localStorage.setItem(VISITOR_PUBLIC_ID_KEY, data?.visitorPublicId);
  }, [data?.visitorPublicId, visitorPublicId]);

  if (!visitorPublicId) return null;

  return <>{children}</>;
}
